import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IvrActionDataFragment = { __typename?: 'IvrAction', id: number, ivrActionType?: Types.IvrActionType | null, button: number, targetNumberId?: number | null, targetNumber?: string | null, downloadToken?: string | null, connectionPrompt?: { __typename?: 'Media', id: number, description?: string | null } | null };

export type IvrProfileContentFragment = { __typename?: 'IvrProfile', instantConnect: boolean, timeout: number, actions: Array<{ __typename?: 'IvrAction', id: number, ivrActionType?: Types.IvrActionType | null, button: number, targetNumberId?: number | null, targetNumber?: string | null, downloadToken?: string | null, connectionPrompt?: { __typename?: 'Media', id: number, description?: string | null } | null }>, greetings: Array<{ __typename?: 'IvrGreeting', orderNumber: number, isGreeting: boolean, downloadToken?: string | null, disabled: boolean, media?: { __typename?: 'Media', id: number, description?: string | null } | null }> };

export type IvrProfileDataSourceQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  ivrId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type IvrProfileDataSourceQuery = { __typename?: 'Query', currentIvr?: { __typename?: 'IvrList', items: Array<{ __typename?: 'Ivr', id: number, name: string, profiles: Array<{ __typename?: 'IvrProfile', id: number, name: string, active: boolean, stickyProfile: boolean, instantConnect: boolean, timeout: number, activationTimes: Array<{ __typename?: 'IvrProfileActivationTime', weekday: Types.Weekday, activationTime: string }>, specialDays: Array<{ __typename?: 'IvrProfileSpecialDay', day: string, everyYear: boolean, activationTime?: string | null }>, submenus: Array<{ __typename?: 'IvrProfile', id: number, instantConnect: boolean, timeout: number, ivr?: { __typename?: 'Ivr', number?: { __typename?: 'Number', id: number } | null } | null, actions: Array<{ __typename?: 'IvrAction', id: number, ivrActionType?: Types.IvrActionType | null, button: number, targetNumberId?: number | null, targetNumber?: string | null, downloadToken?: string | null, connectionPrompt?: { __typename?: 'Media', id: number, description?: string | null } | null }>, greetings: Array<{ __typename?: 'IvrGreeting', orderNumber: number, isGreeting: boolean, downloadToken?: string | null, disabled: boolean, media?: { __typename?: 'Media', id: number, description?: string | null } | null }> }>, actions: Array<{ __typename?: 'IvrAction', id: number, ivrActionType?: Types.IvrActionType | null, button: number, targetNumberId?: number | null, targetNumber?: string | null, downloadToken?: string | null, connectionPrompt?: { __typename?: 'Media', id: number, description?: string | null } | null }>, greetings: Array<{ __typename?: 'IvrGreeting', orderNumber: number, isGreeting: boolean, downloadToken?: string | null, disabled: boolean, media?: { __typename?: 'Media', id: number, description?: string | null } | null }> }>, number?: { __typename?: 'Number', id: number, shortNumber?: string | null, domain: { __typename?: 'Domain', domainType: Types.DomainType } } | null } | null> } | null, ivrTargets?: { __typename?: 'IvrList', items: Array<{ __typename?: 'Ivr', id: number, name: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, faxes?: { __typename?: 'FaxList', items: Array<{ __typename?: 'Fax', id: number, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, name: string, groupType: Types.GroupType, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null };

export const IvrActionDataFragmentDoc = gql`
    fragment IvrActionData on IvrAction {
  id
  ivrActionType
  button
  targetNumberId
  targetNumber
  downloadToken
  connectionPrompt {
    id
    description
  }
}
    `;
export const IvrProfileContentFragmentDoc = gql`
    fragment IvrProfileContent on IvrProfile {
  actions {
    ...IvrActionData
  }
  greetings {
    orderNumber
    isGreeting
    downloadToken
    disabled
    media {
      id
      description
    }
  }
  instantConnect
  timeout
}
    ${IvrActionDataFragmentDoc}`;
export const IvrProfileDataSourceDocument = gql`
    query IvrProfileDataSource($domainId: Int!, $ivrId: Int) {
  currentIvr: ivrs(id: $ivrId) {
    items {
      id
      name
      profiles {
        id
        name
        active
        stickyProfile
        ...IvrProfileContent
        activationTimes {
          weekday
          activationTime
        }
        specialDays {
          day
          everyYear
          activationTime
        }
        submenus {
          id
          ivr {
            number {
              id
            }
          }
          ...IvrProfileContent
        }
      }
      number {
        id
        shortNumber
        domain {
          domainType
        }
      }
    }
  }
  ivrTargets: ivrs(domainId: $domainId, notId: $ivrId) {
    items {
      id
      name
      number {
        id
        shortNumber
      }
    }
  }
  faxes(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
    }
  }
  groups(domainId: $domainId) {
    items {
      id
      name
      number {
        id
        shortNumber
      }
      groupType
    }
  }
  users(domainId: $domainId) {
    items {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
  }
}
    ${IvrProfileContentFragmentDoc}`;

/**
 * __useIvrProfileDataSourceQuery__
 *
 * To run a query within a React component, call `useIvrProfileDataSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useIvrProfileDataSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIvrProfileDataSourceQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      ivrId: // value for 'ivrId'
 *   },
 * });
 */
export function useIvrProfileDataSourceQuery(baseOptions: Apollo.QueryHookOptions<IvrProfileDataSourceQuery, IvrProfileDataSourceQueryVariables> & ({ variables: IvrProfileDataSourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IvrProfileDataSourceQuery, IvrProfileDataSourceQueryVariables>(IvrProfileDataSourceDocument, options);
      }
export function useIvrProfileDataSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IvrProfileDataSourceQuery, IvrProfileDataSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IvrProfileDataSourceQuery, IvrProfileDataSourceQueryVariables>(IvrProfileDataSourceDocument, options);
        }
export function useIvrProfileDataSourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IvrProfileDataSourceQuery, IvrProfileDataSourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IvrProfileDataSourceQuery, IvrProfileDataSourceQueryVariables>(IvrProfileDataSourceDocument, options);
        }
export type IvrProfileDataSourceQueryHookResult = ReturnType<typeof useIvrProfileDataSourceQuery>;
export type IvrProfileDataSourceLazyQueryHookResult = ReturnType<typeof useIvrProfileDataSourceLazyQuery>;
export type IvrProfileDataSourceSuspenseQueryHookResult = ReturnType<typeof useIvrProfileDataSourceSuspenseQuery>;
export type IvrProfileDataSourceQueryResult = Apollo.QueryResult<IvrProfileDataSourceQuery, IvrProfileDataSourceQueryVariables>;